export const CreateModes = {
  EDIT: 'edit',
  VIEW: 'view',
  PREVIEW: 'preview',
};
